module.exports = __webpack_public_path__ + "static/media/front.79b2953f.jpg";